import React, { useState, useEffect } from 'react';
import PromoBanner from '../Components/PromoBanner';
import Navbar from '../Components/Navbar';
import MoreHelpSection from '../Components/MoreHelpSection';
import Sample from '../Components/Sample';
import Subscribe from '../Components/SubscribeSection';
import FixedImageMessage from '../Components/FixedImageMessage';
import Footer from '../Components/Footer';
import CallCenter from '../Images/callCenter.jpg'; 
import plus from '../Images/plus1.png'; 

const HelpAndSupport = () => {
  const [faqs, setFaqs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchFaqs();
  }, []);

  const fetchFaqs = async () => {
    setIsLoading(true);
    try {
      const response = await fetch('https://backend.printtrio.co.uk/api/faqs/get-faq');
      const data = await response.json();
      if (data.success) {
        setFaqs(data.data);
      } else {
        console.error('Error fetching FAQs:', data.errors);
      }
    } catch (error) {
      console.error('Error fetching FAQs:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <PromoBanner />
      <Navbar />
      {isLoading ? (
      <div className="flex justify-center items-center h-screen">
        {/* Tailwind simple spinner */}
        <svg
          className="animate-spin h-12 w-12 text-pink-500"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v8H4z"
          />
        </svg>
      </div>
    ) : (
      <>
      <header className="relative z-0 max-w-screen-xl mx-auto px-4 xl:px-20 relative">
        <img
          src={CallCenter}
          alt="Help and Support"
          className="w-full h-96"
        />
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="absolute inset-0 flex flex-col items-start justify-center text-white px-28">
          <h1 className="text-4xl font-bold">Help And Support</h1>
          <p className="mt-4 text-center">
            We're here to help! Whether you have question, need assistance with an order,
          </p>
          <p className="text-center">
          or have any other concerns, our specialised team is ready to assist.
          </p>
        </div>
      </header>
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold">FAQs</h2>
            <p className="mt-6 text-gray-600 px-80">
            Find answers to common questions about our services, print options, support, timelines, and environmental practices in our FQAs-your go-to resource for quick and helpful Information.            </p>
          </div>
          <div className="bg-white shadow-lg rounded-lg p-8 px-32">
    
              {faqs.map((faq, index) => (
                <div key={index} className="mb-4">
                  <details className="group">
                    <summary className="flex justify-between items-center font-semibold cursor-pointer list-none">
                      {faq.question}
                      <span className="group-open:rotate-45 transition-transform duration-300 mt-8">
                        <img src={plus} className="w-4 h-4" />
                      </span>
                    </summary>
                    <div className="mt-3 text-gray-600">
                      <p>{faq.answer}</p>
                    </div>
                  </details>
                </div>
              ))
            }
          </div>
        </div>
      </section>
      {/* <MoreHelpSection /> */}
      <Sample />
      <Subscribe />
      <FixedImageMessage />
      <Footer />
      </>
    )}
    </div>
  );
};

export default HelpAndSupport;
